import React, { useState } from 'react';
import { Popover, PopoverBody } from 'reactstrap';
import help from '../images/svg_icons/help-round.svg';
import exit from '../images/svg_icons/exit.svg';
import '../scss/_recommendedServices.scss';

const InfoPopover = props => {
    const [open, setOpen] = useState(false);

    const handleClick = (e) => {
        e.stopPropagation();
        setOpen(!open);
    }

    return <span>
        <img src={help} alt="help" id={props.id} className="cursor-pointer mg-lft-8" onClick={handleClick} />
        <Popover placement="bottom-end" isOpen={open} target={props.id}
            popperClassName="info-popover"
            toggle={() => setOpen(!open)}>
            <PopoverBody>
                <img src={exit} alt="exit" className="close-button" onClick={handleClick} />
                {props.children}
            </PopoverBody>
        </Popover>
    </span>
}

export default InfoPopover;

export const PrivateListingPopover = props =>
    <InfoPopover id={`private-listing-${props.id}${props.isModal ? '-modal' : ''}`}>
        <div>
            <p>Private listings are properties that are listed with a broker in the MLS that aren’t quite ready for the public.</p>
            <p>These listings may not contain all the information about the property, so there may be listings that fit your search criteria that don’t appear in your results.</p>
            <p className="mg-btm-0">Make sure you connect with your broker for full details as these are often only found in the MLS.</p>
        </div>
    </InfoPopover> 